import HttpService from './httpService';
import { Coupon, CreateCouponInput, UpdateCouponInput } from '../types/coupon';

export class CouponService {
  static createCoupon = async (payload: CreateCouponInput) => {
    return HttpService.post<Coupon>('/coupons', payload);
  };

  static updateCoupon = async (id: string, payload: UpdateCouponInput) => {
    return HttpService.patch<Coupon>(`/coupons/${id}`, payload);
  };

  static deleteCoupon = async (id: string) => {
    return HttpService.delete<void>(`/coupons/${id}`);
  };

  static getActiveCoupons = async () => {
    return HttpService.get<Coupon[]>(`/coupons/active`);
  };

  static getCouponById = async (id: string) => {
    return HttpService.get<Coupon>(`/coupons/${id}`);
  };

  static getAllCoupons = async () => {
    return HttpService.get<Coupon[]>(`/coupons`);
  };
}

export default CouponService;


